
    <ng-container *ngIf="params.data.assignees?.length; else noData">
      <ng-container *ngIf="params.data.assignees.length > 1; else showNames">
        <app-user-icon-list
          [usersList]="params.data.assignees.length"
          [imageList]="params.data.assignees"
          [isGridCell]="params.eGridCell ? true : false"
          [useInitialsFallback]="true">
        </app-user-icon-list>
      </ng-container>

      <ng-template #showNames>
        <div class="user-profiles">
          <div class="user" *ngFor="let user of params.data.assignees">
            <img
              *ngIf="user?.profilepicture"
              [src]="user.profilepicture"
              class="user-avatar"
            />
            <div *ngIf="!user?.profilepicture" class="user-avatar user-avatar-initials">{{ getInitials(user?.username) }}</div>
            <span class="user-name">{{ user?.username }}</span>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <ng-template #noData>
        <img
            [src]="fallbackImage"
            class="user-avatar"
        />
      <span class="space-between-img">Unassigned</span>
    </ng-template>
  